module.exports = __webpack_public_path__ + "media/loketpendaftaran1.020bb6a9.mp3";